import { getCurrentLang, stripLang } from "./LanguageContext";
import ru from "./ru.json";
import en from "./en.json";

const dicts = { ru, en };
const SUMMARY_LENGTH = 155;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Sets <title>, meta description and Open Graph tags for the current page.
export const setPageMeta = ({ title, description }) => {
  const d = dicts[getCurrentLang()] || ru;
  const fullTitle = title || d["seo.default.title"];
  const desc = description || d["seo.default.description"];
  document.title = fullTitle;
  setMeta("name", "description", desc);
  setMeta("property", "og:title", fullTitle);
  setMeta("property", "og:description", desc);
  setMeta("property", "og:url", window.location.origin + window.location.pathname);
  setMeta("property", "og:locale", getCurrentLang() === "en" ? "en_GB" : "ru_RU");
};

// Static per-route meta from the locale file (keys "seo.<path>.title" / ".description"); falls back to defaults.
export const setRouteMeta = (pathname) => {
  const d = dicts[getCurrentLang()] || ru;
  const base = stripLang(pathname);
  const key = base.startsWith("/events/") ? "/events/:id" : base.startsWith("/organizers/") && base !== "/organizers/apply" ? "/organizers/:id" : base;
  setPageMeta({ title: d[`seo.${key}.title`], description: d[`seo.${key}.description`] });
};

export const summarize = (text) => {
  const clean = (text || "").replace(/\s+/g, " ").trim();
  return clean.length > SUMMARY_LENGTH ? `${clean.slice(0, SUMMARY_LENGTH - 1).trimEnd()}…` : clean;
};
